$(document).on('click', '.accordion-item__header', function (e) {
  var $item = $(this).closest('.accordion-item');
  var $accordion = $item.closest('.accordion');
  if ($accordion.length == 0) {
    $accordion = $item.closest('[data-accordion-parent]');
  }
  var $content = $item.children('.accordion-item__main');
  var isActive = $item.hasClass('active');

  // $accordion.css('border', '1px solid red');
  $accordion.children('.accordion-item').removeClass('active');
  $accordion.children('.accordion-item').find('.accordion-item__main').slideUp();
  // $accordion.children('.accordion__item').removeClass('active');

  if (isActive) {
    $content.slideUp(function () {
      // smootherRefresh();
    });
    $item.removeClass('active');
  } else {
    $content.slideDown(function () {
      // smootherRefresh();
    });
    $item.addClass('active');
  }
});
